import React, { memo } from 'react';
import { View, Image } from 'react-native';
import {
  Text,
  IconPlus,
  IconButton,
  IconClose,
  Space,
} from '@redlink/components/atoms';
import { createUseStyle } from '@redlink/assets/styles';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

export const ImageUploaderItem = memo(
  ({ status, placehoder, text, progress = 0, onRemove, thumbnale }) => {
    const { styles, colors } = useStyle();

    const isEmpty = status === ImageUploaderItem.status.none;
    const isBusy = status === ImageUploaderItem.status.busy;
    const isSelected = status === ImageUploaderItem.status.selected;

    return (
      <View style={styles.container}>
        {isEmpty && (
          <>
            <Text style={styles.placeholderText}>{placehoder}</Text>
            <IconPlus />
          </>
        )}
        {isSelected && (
          <>
            {thumbnale && (
              <Image
                source={{ uri: thumbnale }}
                style={styles.thumbnaleImage}
              />
            )}
            <Space size={8} />
            <Text en style={styles.text} numberOfLines={1}>
              {text}
            </Text>
            <IconButton
              transparent
              onPress={onRemove}
              style={styles.actionButton}
            >
              <IconClose />
            </IconButton>
          </>
        )}
        {isBusy && (
          <>
            <Text style={styles.text} numberOfLines={1}>
              {text}
            </Text>
            <Space />
            <View style={styles.progressContainer}>
              <Text style={styles.progressText}>{`${progress}%`}</Text>
              <Space size={5} />
              <View style={styles.progressIndicatorContainer}>
                <CircularProgressbar
                  strokeWidth={15}
                  value={progress}
                  styles={buildStyles({
                    strokeLinecap: 'butt',
                    pathColor: colors.green1,
                    trailColor: colors.gray22,
                  })}
                />
              </View>
            </View>
          </>
        )}
      </View>
    );
  }
);

ImageUploaderItem.status = {
  none: 1,
  busy: 2,
  selected: 3,
};

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    borderWidth: 1,
    borderColor: colors.black3,
    borderRadius: 4,
    overflow: 'hidden',
    paddingHorizontal: 8,
    paddingVertical: 4,
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 40,
  },
  placeholderText: {
    flex: 1,
    fontSize: 12,
    color: colors.gray21,
    textAlign: 'left',
    marginTop: 3,
  },
  text: {
    flex: 1,
    fontSize: 14,
    color: colors.gray23,
    textAlign: 'left',
  },
  actionButton: {
    width: 20,
    height: 20,
  },
  progressContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  progressIndicatorContainer: {
    width: 24,
    height: 24,
  },
  progressText: {
    fontSize: 14,
    color: colors.gray23,
    marginTop: 5,
  },
  thumbnaleImage: {
    width: 40,
    height: 40,
  },
}));
